/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import React from 'react';
import 'jspreadsheet-ce/dist/jspreadsheet.css';
import routes from "../../Routes/routes";
import ButtonAction from "../../components/buttons/ButtonAction";
import HeadTittle from "../../components/HeadTittle";
import DivContainerBody from "../../components/DivContainerBody";
import CommonCreationErrorsApp from "./Functionality/CommonCreationErrorsApp";
import CreationErrorsContractorApp from "./Functionality/CreationErrorsContractorApp";
import CreationErrorsBody from "./SubComponents/CreationErrorsBody";
import {permissionObj} from "../../Helpers/permission";
import {MODELS} from "../../Apis/Models";
import {columnCode} from "../../enums/columnCodeEnumsContractor";

const CreationErrorsContractor = () => {
    const props = CommonCreationErrorsApp({
        moduleId: MODELS.Contractor,
        goBack:routes.contractor.list,
        columns:new Array(11).fill({ type: 'text', width: 100 })
    });
    const {t, DEV, permission, navigate, errorsArray, jRef, totalErrors, selectedErrorIndex} = props;
    const {handleConfirm, handleUploadFile} = CreationErrorsContractorApp(props);

    if(!DEV && (!permission?.includes(permissionObj.WEB_CONTRACTOR_READ) || !permission?.includes(permissionObj.WEB_CONTRACTOR_IMPORT))) navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={t('import')} link={routes.contractor.list}>
                {totalErrors === 0 ? (
                        <ButtonAction
                            id='btn_cec_import'
                            name='import'
                            className='btn-icon-accent-450'
                            onClick={handleConfirm}
                        />
                ) : (
                    <ButtonAction
                        id='btn_cec_verify'
                        name='verify'
                        className='btn-icon-accent-450'
                        onClick={handleUploadFile}
                    />
                )}
            </HeadTittle>
            <DivContainerBody>
                <CreationErrorsBody
                    mainJRef={{name:t('excel'), jRef:jRef}}
                    totalErrors={totalErrors}
                    errorsArray={errorsArray}
                    selectedErrorIndex={selectedErrorIndex}
                    columnCode={columnCode}
                />
            </DivContainerBody>
        </>
    );
};

export default CreationErrorsContractor;
